import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

import { toast } from "react-toastify";
import { sendOtp } from "../../../services/auth";
import { convertToEnglishNumber, getOtpSendErrorMessage } from "../../../utils";
import { phoneSchema, type PhoneForm } from "../schema/auth.scehma";

interface MobileStepProps {
  onSuccess: (phone: string) => void;
}

export const MobileStep = ({ onSuccess }: MobileStepProps) => {
  const { register, handleSubmit } = useForm<PhoneForm>({
    resolver: zodResolver(phoneSchema),
    mode: "onChange",
    defaultValues: {
      phoneNumber: "",
    },
  });

  const { mutate, isPending: isSendOtpPending } = useMutation({
    mutationFn: sendOtp,
  });

  const onSubmit = (data: PhoneForm) => {
    const phoneNumber = convertToEnglishNumber(data.phoneNumber);

    mutate(
      {
        phoneNumber,
      },
      {
        onSuccess: (response) => {
          if (response?.data?.message) {
            toast.success("کد تایید ارسال شد");
          } else {
            toast.success("کد تایید ارسال شد");
          }

          onSuccess(phoneNumber);
        },

        onError: (error) => {
          toast.error(getOtpSendErrorMessage(error));
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4.75">
      <div>
        <input
          {...register("phoneNumber")}
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          placeholder="شماره تلفن همراه"
          className="h-14 w-full rounded-xl text-button-2 font-kalameh text-right bg-white px-4 text-gray-800 outline-none placeholder:text-gray-400 focus:ring-2 focus:ring-[#5abcf0]"
        />
      </div>

      <button
        type="submit"
        disabled={isSendOtpPending}
        className="h-15.5 w-full rounded-xl font-kalameh text-button-1 bg-linear-to-l from-[#4dbcf0] to-[#9b5cff] text-white transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isSendOtpPending ? (
          <p>در حال ارسال...</p>
        ) : (
          <div className="flex text-center items-center justify-center gap-3">
            <p>وارد شو</p>
            <img
              src="/images/arrow_right.png"
              alt="arrow"
              className="w-5.75 h-5.75"
            />
          </div>
        )}
      </button>
    </form>
  );
};
